var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 120,
    viewBox: "0 0 296 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12675_6744)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.168 64.0705C223.584 70.1373 221.325 76.3637 217.154 82.2524C212.121 89.3571 205.346 100.852 195.556 105.965C162.814 123.063 107.414 122.853 64.8902 109.892C64.2461 109.698 63.6214 109.502 62.995 109.284C62.9152 109.268 62.8335 109.229 62.7537 109.213C56.4025 107.173 50.3519 104.726 44.6762 101.821C35.3947 97.0778 27.1586 91.1934 20.487 84.0357C20.2079 83.7441 19.9483 83.4509 19.6887 83.1577C13.3188 76.0875 8.42139 67.8189 5.52122 58.2863C5.30497 57.5629 5.11005 56.8601 4.91513 56.1574C-2.70116 27.1341 15.4192 1.21576 44.7104 1.69417C71.5048 2.1298 79.1357 13.0945 99.913 20.1314C120.688 27.1459 147.03 21.0804 168.654 18.5477C176.062 17.6721 183.828 18.7661 188.921 19.8318C207.361 23.7359 226.775 36.9603 224.168 64.0705Z",
    fill: "#4182EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.604 5.99013L50.6668 49.4542L50.7141 49.4478C49.6581 50.1885 49.0493 51.3795 49.2208 52.6343L57.8103 115.497C58.0674 117.379 59.977 118.652 62.1067 118.361L174.509 103.002C176.639 102.711 178.137 100.972 177.88 99.0904L169.29 36.2281C169.119 34.9733 168.213 33.9892 166.997 33.5589L167.092 33.5459L108.135 5.00374C105.705 3.80199 102.629 4.22234 100.604 5.99013Z",
    fill: "url(#paint0_linear_12675_6744)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.604 5.99013L50.6668 49.4542L50.7141 49.4478C50.7031 49.4555 50.6922 49.4632 50.6814 49.471C50.6777 49.4736 50.6739 49.4763 50.6702 49.479C50.242 49.7881 49.8899 50.1721 49.6369 50.6042C49.282 51.2106 49.1221 51.9119 49.2208 52.6343L57.8103 115.497C58.0674 117.379 59.977 118.652 62.1067 118.361L174.509 103.002C176.639 102.711 178.137 100.972 177.88 99.0904L169.29 36.2281C169.191 35.5057 168.849 34.873 168.345 34.3841C167.998 34.0477 167.573 33.7794 167.099 33.5967C167.09 33.5933 167.081 33.5899 167.072 33.5866C167.047 33.5771 167.022 33.5679 166.997 33.5589L167.092 33.5459L108.135 5.00374C105.705 3.80199 102.629 4.22234 100.604 5.99013ZM166.672 34.4129L166.656 34.446L107.692 5.90015C105.628 4.87932 102.985 5.23866 101.262 6.74336L101.261 6.74444L51.3234 50.2085L51.2183 50.0878L51.2883 50.2664C50.4914 50.8255 50.0982 51.6691 50.2116 52.4989L58.8011 115.361C58.9682 116.585 60.2701 117.602 61.9713 117.37L174.374 102.011C176.075 101.779 177.056 100.449 176.889 99.2257L168.299 36.3635C168.186 35.5336 167.581 34.8264 166.663 34.5017L166.672 34.4129Z",
    fill: "url(#paint1_linear_12675_6744)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12675_6744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 7,
    width: 103,
    height: 73
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8767 20.2892L150.092 7.96221C152.188 7.67589 154.119 9.14245 154.405 11.2379L158.195 38.9793L148.093 49.1365L147.983 49.2793L139.812 57.5109L133.87 63.478L121.58 75.8939L119.198 78.307L117.6 77.6307C115.13 76.5622 112.215 76.9605 110.128 78.6943L108.769 79.7747L106.205 78.3355L90.4875 69.4484L83.1631 65.2939L73.0775 59.5143L71.2104 58.4487L60.3919 52.3433L56.6011 24.6017C56.3148 22.5063 57.7813 20.5756 59.8767 20.2892Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8767 20.2892L150.092 7.96221C152.188 7.67589 154.119 9.14245 154.405 11.2379L158.195 38.9793L148.093 49.1365L147.983 49.2793L139.812 57.5109L133.87 63.478L121.58 75.8939L119.198 78.307L117.6 77.6307C115.13 76.5622 112.215 76.9605 110.128 78.6943L108.769 79.7747L106.205 78.3355L90.4875 69.4484L83.1631 65.2939L73.0775 59.5143L71.2104 58.4487L60.3919 52.3433L56.6011 24.6017C56.3148 22.5063 57.7813 20.5756 59.8767 20.2892Z",
    fill: "url(#paint2_linear_12675_6744)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.753 48.7989L147.732 48.8207L147.713 48.845L147.622 48.9637L139.473 57.1732L139.472 57.1737L133.531 63.1402L133.53 63.1412L121.24 75.5571L121.239 75.5577L119.086 77.7396L117.79 77.1914C117.789 77.191 117.788 77.1907 117.787 77.1903C115.156 76.0531 112.052 76.4759 109.826 78.3226C109.825 78.3238 109.823 78.3249 109.822 78.3261L108.723 79.1998L106.441 77.9189L106.44 77.9181L90.7237 69.032L90.7231 69.0317L83.4011 64.8786L83.3993 64.8776L73.3155 59.099L73.3148 59.0986L71.4477 58.033L71.4457 58.0318L60.834 52.0432L57.0753 24.5369C57.0753 24.5369 57.0753 24.5369 57.0753 24.5369C56.8248 22.7035 58.1081 21.014 59.9415 20.7635L150.157 8.43647C151.991 8.18594 153.68 9.46918 153.931 11.3027L157.689 38.8096L147.753 48.7989Z",
    stroke: "url(#paint3_linear_12675_6744)",
    strokeOpacity: 0.4,
    strokeWidth: 0.957334
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12675_6744)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8412 19.7476L146.129 8.50379C150.414 7.91835 154.362 10.9171 154.947 15.2017L158.196 38.9793L158.196 38.9795L158.196 38.9795L148.093 49.1365L147.984 49.2793L139.812 57.5109L133.871 63.4779L121.581 75.8939L119.199 78.3069L117.6 77.6307C115.13 76.5622 112.215 76.9605 110.128 78.6943L108.77 79.7746L106.206 78.3355L90.4882 69.4484L83.1638 65.2939L73.0781 59.5143L71.2111 58.4487L60.3926 52.3433L60.3923 52.3433L60.3923 52.3432L57.1434 28.5655C56.5579 24.281 59.5566 20.333 63.8412 19.7476Z",
    fill: "url(#paint4_linear_12675_6744)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.809 27.3425L111.918 31.7C111.394 31.7716 111.027 32.2543 111.099 32.7782L111.487 35.6214C111.559 36.1452 112.042 36.5119 112.566 36.4403L144.456 32.0828C144.98 32.0112 145.347 31.5285 145.275 31.0046L144.887 28.1614C144.815 27.6375 144.333 27.2709 143.809 27.3425ZM145.527 39.9157L113.637 44.2732C113.113 44.3448 112.746 44.8275 112.818 45.3513L113.206 48.1946C113.278 48.7184 113.76 49.0851 114.284 49.0135L146.175 44.6559C146.699 44.5844 147.066 44.1017 146.994 43.5778L146.606 40.7346C146.534 40.2107 146.051 39.8441 145.527 39.9157ZM115.354 56.8466L147.245 52.4891C147.769 52.4175 148.252 52.7841 148.323 53.308L148.712 56.1512C148.783 56.6751 148.417 57.1578 147.893 57.2294L116.002 61.5869C115.478 61.6585 114.996 61.2918 114.924 60.768L114.535 57.9248C114.464 57.4009 114.831 56.9182 115.354 56.8466Z",
    fill: "url(#paint5_linear_12675_6744)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.89 27.937L111.999 32.2945C111.804 32.3212 111.667 32.5014 111.693 32.6969L112.082 35.5402C112.109 35.7357 112.289 35.8725 112.484 35.8458L144.375 31.4883C144.571 31.4616 144.708 31.2814 144.681 31.0859L144.292 28.2426C144.266 28.0471 144.085 27.9102 143.89 27.937ZM145.609 40.5101L113.718 44.8677C113.522 44.8944 113.385 45.0746 113.412 45.2701L113.801 48.1133C113.827 48.3089 114.008 48.4457 114.203 48.419L146.094 44.0615C146.289 44.0347 146.426 43.8546 146.4 43.659L146.011 40.8158C145.984 40.6203 145.804 40.4834 145.609 40.5101ZM147.326 53.0836L115.436 57.4411C115.24 57.4678 115.103 57.648 115.13 57.8435L115.518 60.6868C115.545 60.8823 115.725 61.0192 115.921 60.9924L147.812 56.6349C148.007 56.6082 148.144 56.428 148.117 56.2325L147.729 53.3892C147.702 53.1937 147.522 53.0568 147.326 53.0836ZM111.918 31.7L143.809 27.3425C144.333 27.2709 144.815 27.6375 144.887 28.1614L145.275 31.0046C145.347 31.5285 144.98 32.0112 144.456 32.0828L112.566 36.4403C112.042 36.5119 111.559 36.1452 111.487 35.6214L111.099 32.7782C111.027 32.2543 111.394 31.7716 111.918 31.7ZM113.637 44.2732L145.527 39.9157C146.051 39.8441 146.534 40.2107 146.606 40.7346L146.994 43.5778C147.066 44.1017 146.699 44.5844 146.175 44.6559L114.284 49.0135C113.76 49.0851 113.278 48.7184 113.206 48.1946L112.818 45.3513C112.746 44.8275 113.113 44.3448 113.637 44.2732ZM147.245 52.4891L115.354 56.8466C114.831 56.9182 114.464 57.4009 114.535 57.9248L114.924 60.768C114.996 61.2918 115.478 61.6585 116.002 61.5869L147.893 57.2294C148.417 57.1578 148.783 56.6751 148.712 56.1512L148.323 53.308C148.252 52.7841 147.769 52.4175 147.245 52.4891Z",
    fill: "url(#paint6_linear_12675_6744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.438 32.2638L73.1468 35.9928C70.9799 36.2889 69.4633 38.2856 69.7594 40.4525L73.1007 64.9059C73.3968 67.0728 75.3934 68.5894 77.5604 68.2933L104.851 64.5643C107.018 64.2682 108.535 62.2715 108.238 60.1046L104.897 35.6513C104.601 33.4843 102.604 31.9677 100.438 32.2638Z",
    fill: "url(#paint7_linear_12675_6744)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.567 33.2123L73.2764 36.9413C71.6334 37.1658 70.4834 38.6798 70.7079 40.3229L74.0492 64.7762C74.2737 66.4193 75.7877 67.5693 77.4307 67.3448L104.721 63.6158C106.364 63.3913 107.514 61.8773 107.29 60.2342L103.949 35.7809C103.724 34.1378 102.21 32.9878 100.567 33.2123ZM73.1468 35.9928L100.438 32.2638C102.604 31.9677 104.601 33.4843 104.897 35.6513L108.238 60.1046C108.535 62.2715 107.018 64.2682 104.851 64.5643L77.5604 68.2933C75.3934 68.5894 73.3968 67.0728 73.1007 64.9059L69.7594 40.4525C69.4633 38.2856 70.9799 36.2889 73.1468 35.9928Z",
    fill: "url(#paint8_linear_12675_6744)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 99.1876L119.451 80.1477L117.861 79.5314C115.404 78.5571 112.489 78.9554 110.388 80.5921L109.021 81.6125L68.6397 112.696L106.516 80.2875L109.83 77.4528C112.131 75.3918 115.595 74.9184 118.322 76.2925L121.815 77.9192L167.5 99.1876Z",
    fill: "url(#paint9_linear_12675_6744)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.7568,
    y: 62.929,
    width: 10,
    height: 2.5,
    transform: "rotate(-32.0546 31.7568 62.929)",
    fill: "url(#paint10_linear_12675_6744)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5303,
    y: 48.5154,
    width: 10,
    height: 2.5,
    transform: "rotate(6.31821 29.5303 48.5154)",
    fill: "url(#paint11_linear_12675_6744)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.332,
    y: 35.72,
    width: 10,
    height: 2.5,
    transform: "rotate(44.7571 36.332 35.72)",
    fill: "url(#paint12_linear_12675_6744)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.703 66.2208L168.056 80.685L177.819 71.3274L216.842 52.5059L171.703 66.2208Z",
    fill: "#B6861D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.703 66.2208L168.056 80.685L177.819 71.3274L216.842 52.5059L171.703 66.2208Z",
    fill: "url(#paint13_linear_12675_6744)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.502 74.4698L168.055 80.685L177.818 71.3274L179.502 74.4698Z",
    fill: "url(#paint14_linear_12675_6744)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.818 71.3271L216.841 52.5056L186.829 88.4654L177.818 71.3271Z",
    fill: "url(#paint15_linear_12675_6744)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.702 66.2208L153.875 56.9842L216.841 52.5059L171.702 66.2208Z",
    fill: "url(#paint16_linear_12675_6744)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6256 68.1323C49.1008 67.7088 49.5931 67.2876 50.1019 66.8691L50.7371 67.6414C50.2381 68.0518 49.756 68.4644 49.291 68.8788L48.6256 68.1323ZM43.3635 73.8332C44.0954 72.8306 44.9246 71.8319 45.8467 70.8418L46.5785 71.5232C45.6811 72.487 44.8776 73.4551 44.1712 74.4228L43.3635 73.8332ZM39.8983 80.8231C40.2096 79.6057 40.6821 78.3796 41.306 77.1538L42.1972 77.6073C41.6029 78.7752 41.1582 79.9325 40.8672 81.0707L39.8983 80.8231ZM164.122 83.9301C163.578 84.2956 163.018 84.6559 162.442 85.0112L161.917 84.1602C162.482 83.8114 163.032 83.458 163.564 83.1001L164.122 83.9301ZM40.3069 88.6501C39.8042 87.3927 39.5283 86.0915 39.4691 84.761L40.4681 84.7166C40.5223 85.9363 40.7749 87.1269 41.2355 88.2788L40.3069 88.6501ZM158.977 86.9938C157.828 87.6056 156.634 88.2007 155.401 88.7791L154.976 87.8739C156.195 87.3019 157.374 86.7143 158.507 86.1111L158.977 86.9938ZM151.761 90.3949C150.553 90.9024 149.317 91.3957 148.058 91.8749L147.703 90.9403C148.952 90.4649 150.177 89.9758 151.373 89.473L151.761 90.3949ZM45.1309 94.8103C44.0356 93.9399 43.102 93.021 42.3273 92.0594L43.1059 91.432C43.8297 92.3303 44.7093 93.198 45.753 94.0274L45.1309 94.8103ZM144.319 93.234C143.075 93.6662 141.814 94.0854 140.541 94.4918L140.237 93.5391C141.503 93.1352 142.756 92.7186 143.991 92.2894L144.319 93.234ZM136.739 95.6563C135.47 96.0295 134.193 96.3904 132.912 96.7388L132.65 95.7739C133.924 95.4271 135.195 95.0682 136.457 94.697L136.739 95.6563ZM51.871 98.6877C50.6081 98.1518 49.4459 97.5819 48.3822 96.9806L48.8743 96.1101C49.9021 96.6911 51.0302 97.2446 52.2616 97.7671L51.871 98.6877ZM129.065 97.7456C127.776 98.0703 126.486 98.3825 125.201 98.6822L124.974 97.7083C126.254 97.4099 127.538 97.0991 128.821 96.7759L129.065 97.7456ZM121.324 99.5517C120.016 99.8337 118.716 100.103 117.429 100.358L117.234 99.3773C118.516 99.1227 119.81 98.855 121.113 98.5741L121.324 99.5517ZM59.1996 101.112C57.8961 100.779 56.6614 100.421 55.4941 100.039L55.8052 99.0884C56.9501 99.4632 58.1635 99.8154 59.4472 100.143L59.1996 101.112ZM113.526 101.101C112.198 101.343 110.891 101.57 109.608 101.782L109.445 100.795C110.722 100.584 112.025 100.358 113.346 100.117L113.526 101.101ZM66.7739 102.635C65.4545 102.432 64.1868 102.208 62.9698 101.966L63.1653 100.985C64.3671 101.224 65.6204 101.445 66.926 101.646L66.7739 102.635ZM105.684 102.397C104.329 102.597 103.012 102.779 101.739 102.943L101.611 101.952C102.878 101.788 104.189 101.607 105.537 101.408L105.684 102.397ZM74.4188 103.53C73.1034 103.419 71.8285 103.292 70.5935 103.148L70.7088 102.155C71.9329 102.297 73.1973 102.423 74.5026 102.533L74.4188 103.53ZM97.7901 103.41C96.391 103.56 95.0656 103.683 93.8262 103.781L93.7477 102.784C94.977 102.687 96.2931 102.565 97.6838 102.416L97.7901 103.41ZM82.0748 103.965C80.7656 103.923 79.4894 103.867 78.246 103.797L78.3022 102.798C79.5372 102.868 80.8053 102.924 82.1067 102.965L82.0748 103.965ZM89.842 104.016C89.1324 104.042 88.4702 104.054 87.8597 104.054C87.2016 104.054 86.5509 104.051 85.9075 104.045L85.9177 103.045C86.5576 103.051 87.2049 103.054 87.8597 103.054C88.4566 103.054 89.1067 103.042 89.8063 103.017L89.842 104.016Z",
    fill: "url(#paint17_linear_12675_6744)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12675_6744",
    x1: 150.994,
    y1: 112.32,
    x2: 101.807,
    y2: 10.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0667137,
    stopColor: "#172961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586496,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12675_6744",
    x1: 88.5185,
    y1: -2.34019,
    x2: 189.825,
    y2: 74.0041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12675_6744",
    x1: 73.272,
    y1: 12.8601,
    x2: 85.6936,
    y2: 103.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430736,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12675_6744",
    x1: 104.986,
    y1: 14.1256,
    x2: 113.456,
    y2: 76.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510789,
    stopColor: "#D2DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510889,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12675_6744",
    x1: 73.2718,
    y1: 12.8602,
    x2: 85.6934,
    y2: 103.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430736,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12675_6744",
    x1: 150.434,
    y1: 43.5861,
    x2: 110.577,
    y2: 42.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12675_6744",
    x1: 110.092,
    y1: 45.4751,
    x2: 158.988,
    y2: 77.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93A0CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12675_6744",
    x1: 110.358,
    y1: 49.4421,
    x2: 68.8537,
    y2: 48.1186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12675_6744",
    x1: 108.775,
    y1: 64.0152,
    x2: 77.9132,
    y2: 41.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12675_6744",
    x1: 54.3107,
    y1: 99.1914,
    x2: 176.535,
    y2: 82.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502428,
    stopColor: "#384F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09143F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12675_6744",
    x1: 31.7568,
    y1: 64.3613,
    x2: 35.2483,
    y2: 68.4692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#F3C869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBA46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12675_6744",
    x1: 29.5303,
    y1: 49.9478,
    x2: 33.0218,
    y2: 54.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#F3C869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBA46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12675_6744",
    x1: 36.332,
    y1: 37.1523,
    x2: 39.8235,
    y2: 41.2602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#F3C869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBA46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12675_6744",
    x1: 191.095,
    y1: 53.8085,
    x2: 199.839,
    y2: 75.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425398,
    stopColor: "#C49B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725482,
    stopColor: "#936706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12675_6744",
    x1: 178.895,
    y1: 73.888,
    x2: 167.432,
    y2: 81.1674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426966,
    stopColor: "#846011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12675_6744",
    x1: 199.18,
    y1: 104.541,
    x2: 218.244,
    y2: 49.6086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.160268,
    stopColor: "#C89524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720862,
    stopColor: "#F3C96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CD73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12675_6744",
    x1: 181.289,
    y1: 41.3331,
    x2: 187.224,
    y2: 61.2316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.822162,
    stopColor: "#F2C665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD88A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12675_6744",
    x1: 14.1959,
    y1: 90.3143,
    x2: 158.683,
    y2: 97.0035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7288CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DCF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12675_6744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmation);
export default __webpack_public_path__ + "static/media/email-confirmation.2a2bf22491296c6e3f3a52497dde0f86.svg";
export { ForwardRef as ReactComponent };